import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
} from './styled';

const BuySellTrade = () => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageWrapper>
          <StyledImage
            src={messages['home.buy-sell-trade.image.src']}
            alt={messages['home.buy-sell-trade.image.alt']}
          />
        </ImageWrapper>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id="home.buy-sell-trade.title" />
          </Title>
          <Subtitle>
            <FormattedMessage id="home.buy-sell-trade.paragraph" />
          </Subtitle>
        </Contentwrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default BuySellTrade;
